module.exports = __webpack_public_path__ + "img/lock-half-faded-zoom.9a031ba9.png";